import React, { useEffect, useRef, useState } from 'react'
import styles from '../ChallengeSteps/challengeSteps.module.scss'
import cx from 'classnames'
import CancelBtn from '../../../../icons/cancelBtn.svg'
import AcceptBtn from '../../../../icons/acceptBtn.svg'
import Download from '../../../../icons/download.svg'
import Edit from '../../../../icons/edit.svg'
import {
  setCareReceipients,
  setCommercially,
  setIndividual,
} from '../../../../redux/actions/careReceipients'
import { useDispatch, useSelector } from 'react-redux'
import CheckboxChecked from '../../../../icons/checkbox-checked.svg'
import CheckboxUnchecked from '../../../../icons/checkbxo-unchecked.svg'
import TypingEffect from '../TypingEffect'
import { setConfirmationModal } from '../../../../redux/actions/confirmationModal'
import IndividualModalComponent from '../NestedComponentOfModal/IndividualModalComponent'
import { setToastNotification } from '../../../../redux/actions/toastNotification'
import { deleteFile, uploadFile } from '../../../../api/formApi'
import {
  setCareQuizQuestions,
  setEditFromSummary,
  setPrivateIndividual,
} from '../../../../redux/actions/quizQuestions'
import Close from '../../../../icons/close.svg'
const PrivateIndividualChallenge = ({
  indexPrivate,
  quizPrivate,
  notAPrivateAnsweredIndex,
  editList,
  setEdit,
  getTextValue,
  handlePrivateTextAnswer,
  edit,
  handleEdit,
  handleCancel,
  messageRefs,
}) => {
  const {
    representativePerson,
    representationByPrivateIndividual,
    quizQuestions: { editSummary, groupName, index, availableDays },
    payment: { reimbursementRef },
  } = useSelector((state) => state)
  const fileInputRef = useRef(null)
  const dispatch = useDispatch()
  const [disabled, setDisabled] = useState(false)
  const [fileArray, setFileArray] = useState([])

  useEffect(() => {
    quizPrivate.map((item, i) => {
      if (!!item.edit && index === i) {
        ;(item.type === 'date' ||
          item.type === 'submit' ||
          item.questionKey === 'availableDates' ||
          item.questionKey === 'durationOfAbsence') &&
          handleIndividualModal(item, i)
      }
      if (!!item.edit && index === i) {
        item.type === 'file' && handleDivClick(i)
      }
    })
  }, [groupName])
  const handleDivClick = () => {
    // Simulate click on hidden input when div is clicked
    fileInputRef.current.click()
  }
  const handleFileChange = async (e, ind) => {
    try {
      const file = e.target.files[0]

      // Validation: Ensure a file is selected
      if (!file) {
        dispatch(setEditFromSummary(''))
        console.error('No file selected')
        return
      }
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
      const allowedFileTypes = ['image/jpeg', 'image/png', 'application/pdf']
      if (!allowedFileTypes.includes(file.type)) {
        console.log('Unsupported file type. Please select a JPEG, PNG, or PDF.')
        return
      }
      const maxSizeInBytes = 5 * 1024 * 1024 // 5MB
      if (file.size > maxSizeInBytes) {
        console.log('File size exceeds 5MB.')
        return
      }
      // Create FormData and append the file
      let formData = new FormData()
      formData.append('file', file)

      // Call the upload function
      const res = await uploadFile(
        formData,
        reimbursementRef,
        'RC_TRAVEL_COST_DOCUMENT',
      )

      if (!res || !res.amazonUrl) {
        console.error('File upload failed. Invalid response:', res)
        // alert('Failed to upload the file. Please try again.')
        return
      }

      // Update the quizCare state
      const updatedQuizCare = quizPrivate.map((item, i) => {
        if (i === ind) {
          return {
            ...item,
            answers:
              typeof representationByPrivateIndividual.receiptUpload === 'string'
                ? [{ ...res, name: file.name }]
                : [
                    ...representationByPrivateIndividual.receiptUpload,
                    { ...res, name: file.name },
                  ],
            // Add uploaded file URL
            fileName: file.name, // Add file name for display
          }
        }
        return item
      })
      // Dispatch the actions
      dispatch(
        setIndividual(
          Object.keys(representationByPrivateIndividual)[6],
          typeof representationByPrivateIndividual.receiptUpload === 'string'
            ? [{ ...res, name: file.name }]
            : [
                ...representationByPrivateIndividual.receiptUpload,
                { ...res, name: file.name },
              ],
        ),
      ) // Update careReceipients
      dispatch(setPrivateIndividual(updatedQuizCare, indexPrivate)) // Update quizCare state
      dispatch(setEditFromSummary(''))
      console.log('File uploaded successfully:', res)
    } catch (error) {
      console.error('Error during file upload:', error)
      // alert('An error occurred while uploading the file. Please try again.')
    }
  }
  const handleConstant = () => {
    if (representationByPrivateIndividual.ConsentToTheData === '') {
      dispatch(
        setIndividual(Object.keys(representationByPrivateIndividual)[12], 'checked'),
      )
    } else {
      dispatch(setIndividual(Object.keys(representationByPrivateIndividual)[12], ''))
    }
  }
  const handleIAgree = () => {
    if (representationByPrivateIndividual.iAgree === '') {
      dispatch(
        setIndividual(Object.keys(representationByPrivateIndividual)[13], 'checked'),
      )
    } else {
      dispatch(setIndividual(Object.keys(representationByPrivateIndividual)[13], ''))
    }
  }
  const downloadFile = (url, name) => {
    if (url === '-') {
      return null
    } else {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${name}`)
          document.body.appendChild(link)
          link.click()
          link?.parentNode?.removeChild(link)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
  const handleDeleteFiles = (id, ind) => {
    deleteFile(reimbursementRef, id).then((res) => {
      const filteredFileArray =
        representationByPrivateIndividual.receiptUpload.filter(
          (item) => item.id !== id,
        )

      const updatedQuizCare = quizPrivate.map((item, i) => {
        if (i === ind) {
          return {
            ...item,
            answers: filteredFileArray.length === 0 ? '-' : filteredFileArray,
            // Add uploaded file URL
            // Add file name for display
          }
        }
        return item
      })
      // Dispatch the actions
      dispatch(
        setIndividual(
          Object.keys(representationByPrivateIndividual)[6],
          filteredFileArray.length === 0 ? '-' : filteredFileArray,
        ),
      ) // Update careReceipients
      dispatch(setPrivateIndividual(updatedQuizCare, indexPrivate))
    })
  }
  const handleIHave = () => {
    if (representationByPrivateIndividual.iHave === '') {
      dispatch(
        setIndividual(Object.keys(representationByPrivateIndividual)[14], 'checked'),
      )
    } else {
      dispatch(setIndividual(Object.keys(representationByPrivateIndividual)[14], ''))
    }
  }
  const handlepaid = () => {
    if (representationByPrivateIndividual.paid === '') {
      dispatch(
        setIndividual(Object.keys(representationByPrivateIndividual)[15], 'checked'),
      )
    } else {
      dispatch(setIndividual(Object.keys(representationByPrivateIndividual)[15], ''))
    }
  }
  const handleIndividualModal = (item, i) => {
    dispatch(
      setConfirmationModal({
        headerText: 'Edit',
        body: <IndividualModalComponent item={item} individualIndex={i} />,
        large: true,
      }),
    )
  }
  return (
    <>
      {quizPrivate.slice(0, notAPrivateAnsweredIndex + 1).map((item, i) => {
        return (
          <>
            {item.question && (
              <li
                key={item.questionKey}
                className={cx(styles.odd)}
                ref={(el) =>
                  (messageRefs.current['representationByPrivateIndividual' + i] = el)
                }
              >
                {item.type === 'constant' ? (
                  <p className={styles.checkbox}>
                    <img
                      className={styles.checkboxStyles}
                      src={
                        representationByPrivateIndividual.ConsentToTheData
                          ? CheckboxChecked
                          : CheckboxUnchecked
                      }
                      alt={'Select'}
                      onClick={() => handleConstant(i)}
                    />
                    {item.answers ||
                    representationByPrivateIndividual.ConsentToTheData ? (
                      item.question
                    ) : (
                      <TypingEffect text={item?.question} speed={50} />
                    )}
                  </p>
                ) : item.type === 'iAgree' ? (
                  representationByPrivateIndividual.ConsentToTheData ===
                    'checked' && (
                    <p className={styles.checkbox}>
                      <img
                        className={styles.checkboxStyles}
                        src={
                          representationByPrivateIndividual.iAgree
                            ? CheckboxChecked
                            : CheckboxUnchecked
                        }
                        alt={'Select'}
                        onClick={() => handleIAgree(i)}
                      />
                      {item.answers || representationByPrivateIndividual.iAgree ? (
                        item.question
                      ) : (
                        <TypingEffect text={item?.question} speed={50} />
                      )}
                    </p>
                  )
                ) : item.type === 'iHave' ? (
                  representationByPrivateIndividual.iAgree === 'checked' &&
                  representationByPrivateIndividual.ConsentToTheData ===
                    'checked' && (
                    <p className={styles.checkbox}>
                      <img
                        className={styles.checkboxStyles}
                        src={
                          representationByPrivateIndividual.iHave
                            ? CheckboxChecked
                            : CheckboxUnchecked
                        }
                        alt={'Select'}
                        onClick={() => handleIHave(i)}
                      />
                      {item.answers || representationByPrivateIndividual.iHave ? (
                        item.question
                      ) : (
                        <TypingEffect text={item?.question} speed={50} />
                      )}
                    </p>
                  )
                ) : item.type === 'paid' ? (
                  representationByPrivateIndividual.iAgree === 'checked' &&
                  representationByPrivateIndividual.ConsentToTheData === 'checked' &&
                  representationByPrivateIndividual.iHave === 'checked' && (
                    <p className={styles.checkbox}>
                      <img
                        className={styles.checkboxStyles}
                        src={
                          representationByPrivateIndividual.paid
                            ? CheckboxChecked
                            : CheckboxUnchecked
                        }
                        alt={'Select'}
                        onClick={() => handlepaid(i)}
                      />
                      {item.answers || representationByPrivateIndividual.paid ? (
                        item.question
                      ) : (
                        <TypingEffect text={item?.question} speed={50} />
                      )}
                    </p>
                  )
                ) : (
                  <>
                    <img src={item?.img} alt={item?.img} />
                    <p>
                      {typeof item.answers === 'object' &&
                      item.answers.date &&
                      item.answers ? (
                        item.question
                      ) : (
                        <TypingEffect text={item?.question} speed={50} />
                      )}
                    </p>
                  </>
                )}
              </li>
            )}

            {((item.type === 'group' && item.answers.date) ||
              (item.type !== 'group' && item.answers)) && (
              <li
                className={cx(styles.even, {
                  [styles.fileStyle]: item?.type === 'file',
                  [styles.hideList]: editList !== 1,
                  [styles.borderLi]:
                    !!item.edit && (item.type === 'number' || item.type === 'text'),
                  [styles.fileArray]:
                    item.type === 'file' && !Array.isArray(item.answers),
                })}
                onMouseOver={() => setEdit(i)}
                onMouseOut={() => setEdit(-1)}
              >
                {!!item.edit && (item.type === 'text' || item.type === 'number') ? (
                  <>
                    <textarea
                      maxLength={`${item.type === 'number' && 5}`}
                      onChange={(e) => {
                        item.type === 'number' && !Number(e.currentTarget.value)
                          ? setDisabled(true)
                          : setDisabled(false)
                        item.type === 'number' && !Number(e.currentTarget.value)
                          ? dispatch(
                              setToastNotification({
                                type: 'robotik',
                                toastBody:
                                  'Ups! Hier muss noch etwas korrigiert werden. In diesem Feld können nur Zahlen eingetragen werden.',
                              }),
                            )
                          : getTextValue(e)
                      }}
                      autoFocus={true}
                    >
                      {item?.answers.trim()}
                    </textarea>
                    <div>
                      <img
                        src={CancelBtn}
                        alt={CancelBtn}
                        onClick={() => handleCancel(i)}
                      />
                      <img
                        src={AcceptBtn}
                        alt={AcceptBtn}
                        onClick={() => {
                          !disabled && handlePrivateTextAnswer(i, item.questionKey)
                        }}
                        className={cx({ [styles.disabledImg]: disabled })}
                      />
                    </div>
                  </>
                ) : (
                  <p>
                    {/*{item.question === 'Total amount' ? sumPrivate : item.answers}*/}
                    {item.type === 'text' ||
                    item.type === 'number' ||
                    item.type === 'submit' ||
                    (item.type === 'file' && !Array.isArray(item.answers)) ? (
                      <p>
                        {item?.answers}
                        {item.type === 'file' && !Array.isArray(item.answers) && (
                          <img src={Download} alt={Download} />
                        )}
                      </p>
                    ) : item.type === 'file' ? (
                      <p>
                        {item?.answers.map((ansItem) => {
                          return (
                            <span>
                              {ansItem.name}
                              <button>
                                <img
                                  src={Close}
                                  alt={Close}
                                  onClick={() => handleDeleteFiles(ansItem.id, i)}
                                />
                              </button>
                              <img
                                src={Download}
                                alt="Download"
                                onClick={() =>
                                  downloadFile(ansItem.amazonUrl, ansItem.name)
                                }
                              />
                            </span>
                          )
                        })}
                      </p>
                    ) : (
                      <p>
                        {item.answers?.date && (
                          <p>
                            <span>Datum:</span> <span>{item.answers?.date}</span>
                          </p>
                        )}
                        {item.answers?.duration && (
                          <p>
                            <span>Dauer:</span>
                            <span>{item.answers?.duration}</span>
                          </p>
                        )}
                        {item.answers?.amount && (
                          <p>
                            <span>Betrag:</span>
                            <span>{item.answers?.amount}</span>
                          </p>
                        )}
                      </p>
                    )}
                    {/*{item?.type === 'file' && <img src={Download} alt={Download} />}*/}
                    {/*{item?.type === 'file' && (*/}
                    {/*  <img*/}
                    {/*    src={Download}*/}
                    {/*    alt="Download"*/}
                    {/*    onClick={() =>*/}
                    {/*      downloadFile(careReceipients.certificate, fileName)*/}
                    {/*    }*/}
                    {/*  />*/}
                    {/*)}*/}
                    {edit === i && !editSummary && (
                      <img
                        src={Edit}
                        alt={Edit}
                        onClick={() =>
                          item.type === 'file'
                            ? handleDivClick(i)
                            : item.type === 'date' ||
                                item.type === 'submit' ||
                                item.type === 'group'
                              ? handleIndividualModal(item, i)
                              : handleEdit(i)
                        }
                      />
                    )}
                    {item?.type === 'file' && (
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={(e) => handleFileChange(e, i)}
                        accept="image/jpeg,image/png,.pdf"
                      />
                    )}
                  </p>
                )}
              </li>
            )}
            {}
            {item?.returnQuestion && (
              <div className={styles.returnQuestion}>
                {/*<img src={item?.img} alt={item?.img}/>*/}
                <p>{item?.returnQuestion}</p>
              </div>
            )}
          </>
        )
      })}
    </>
  )
}
export default PrivateIndividualChallenge
